import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'blackAlpha.500',
    w: ['100% + 8px', null, '100%'],
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: ['none', null, 'md'],
    minH: '8',
    h: 'auto',
    px: '4',
    mx: ['-2', null, '0'],
    my: '3',
  },
  link: {
    boxShadow: 'none',
    border: 'none',
    fontSize: 'xs',
    borderRadius: 'none',
    fontFamily: 'accent',
    fontWeight: 'bold',
    lineHeight: '2',
    h: '10',
    color: 'white',
    borderBottom: '3px solid',
    borderBottomColor: 'transparent',
    textTransform: 'uppercase',
    px: '3',
    pt: '2',
    pb: '1',
    sx: {
      '&.active': {
        border: 'none',
        borderBottom: '3px solid',
        color: 'beta.400',
        borderBottomColor: 'beta.400',
        textShadow: '0px 0px 8px rgba(37, 254, 214, 0.6)',
      },
      _hover: {
        textDecoration: 'none',
      },
    },
  },
};
